import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import HomeIcon from '@material-ui/icons/Home';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import AddIcon from '@material-ui/icons/Add';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import DescriptionIcon from '@material-ui/icons/Description';
import BlockIcon from '@material-ui/icons/Block';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: () => (
      <Sidebar>
        <SidebarLogo />
        <SidebarDivider />
        <SidebarGroup label="Studio" icon={<HomeIcon />}>
          <SidebarItem icon={HomeIcon} to="/" text="Home" />
          <SidebarItem icon={LibraryBooksIcon} to="/agents" text="Agent Library" />
          <SidebarItem icon={AddIcon} to="/create/agent" text="Create Agent" />
          <SidebarItem icon={PlayArrowIcon} to="/executions" text="Executions" />
          <SidebarItem icon={DescriptionIcon} to="/documentation" text="Documentation" />
        </SidebarGroup>
        <SidebarDivider />
        <SidebarGroup label="Later" icon={<BlockIcon />}>
          <SidebarItem icon={BlockIcon} to="/journey-packs" text="Journey Packs" />
          <SidebarItem icon={BlockIcon} to="/solution-packs" text="Solution Packs" />
          <SidebarItem icon={BlockIcon} to="/connector-packs" text="Connector Packs" />
          <SidebarItem icon={BlockIcon} to="/evaluations" text="Evaluations" />
          <SidebarItem icon={BlockIcon} to="/governance" text="Governance" />
        </SidebarGroup>
        <SidebarSpace />
      </Sidebar>
    ),
  },
});
